export default ({request}) => ({
  ecomAmzPurchaseDemandListApi(data = {}) {
    return request({
      url: '/ecom/amz/purchase/demand/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzPurchaseDemandSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/purchase/demand/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzPurchaseDemandDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/purchase/demand/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzPurchaseDemandDelApi(data = {}) {
    return request({
      url: '/ecom/amz/purchase/demand/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzPurchaseDemandSkuListApi(data = {}) {
    return request({
      url: '/ecom/amz/purchase/demand/sku/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzPurchaseDemandSkuSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/purchase/demand/sku/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzPurchaseDemandSkuDelApi(data = {}) {
    return request({
      url: '/ecom/amz/purchase/demand/sku/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzPurchaseDemandStoreListApi(data = {}) {
    return request({
      url: '/ecom/amz/purchase/demand/store/list',
      method: 'POST',
      data,
    })
  },
})
